// extracted by mini-css-extract-plugin
export default {"PageCard":"PageCard_PageCard__OfC-T"};